module.exports = __webpack_public_path__ + "static/media/duplicate.2d78c813.svg";